import Button from "@material-ui/core/Button";
import {Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import axios from "axios";
import React, {useState} from "react";

const ChangeCertificateDialog = (props) => {

    const [successOpen, setSuccessOpen] = useState(false);

    const [errorOpen, setErrorOpen] = useState(false);

    const handleSuccessClick = () => {
        setSuccessOpen(true);
    };

    const handleSuccessClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccessOpen(false);
    };

    const handleErrorClick = () => {
        setErrorOpen(true);
    };

    const handleErrorClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorOpen(false);
    };

    const [loading, setLoading] = useState(0)

    const onChangeCertificateClick = () => {
        setLoading(1)
        axios.get('/api/devices/'+props.deviceId+'/change_certificate/')
            .then((res) => {
                console.log('res', res)
                setLoading(0)
                props.onClose()
                handleSuccessClick()
            })
            .catch((err) => {
                console.log('err', err)
                setLoading(0)
                props.onClose()
                handleErrorClick()
            })
    }

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm certificate change"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to change the device certificate?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary">
                        No
                    </Button>
                    <Button onClick={onChangeCertificateClick} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
                <LinearProgress style={{opacity: loading}} color="primary"/>
            </Dialog>
            <Snackbar open={successOpen} autoHideDuration={6000} onClose={handleSuccessClose}>
                <Alert onClose={handleSuccessClose} severity="success">
                    Operation done successfully
                </Alert>
            </Snackbar>
            <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleErrorClose}>
                <Alert onClose={handleErrorClose} severity="error">
                    Error during operation
                </Alert>
            </Snackbar>
        </div>
    );
}

export default ChangeCertificateDialog